(function (c2, $) {
  'use strict';

  /* ── Action inputs drag-to-reorder table (CMP-4068) ──
   *
   * A plain (unpaginated) table of an action's inputs with per-row
   * move-to-top / move-to-bottom chevrons + a drag handle, modeled on the
   * "Display Sequence" table. Reordering POSTs the new HookInput id order to
   * the table's data-resequence-url via c2.sortable.sortableRows (which the
   * existing resequence_action_inputs view reads as seq[]).
   *
   * Used by statically-rendered panels (script/plugin SI details, wired on
   * document ready below) and the action detail overview, which loads the
   * fragment via ajax and calls c2.actionInputs.initAll('#action-inputs').
   */

  function initTable(table) {
    var $table = $(table);
    if ($table.data('ai-inited')) { return; }
    $table.data('ai-inited', true);
    c2.sortable.sortableRows(
      $table.find('tbody'),
      $table.data('resequence-url')
    );
    c2.tooltips.init(table);
  }

  function initAll(context) {
    $('table.js-action-inputs', context || document).each(function () {
      initTable(this);
    });
  }

  // Statically-rendered tables (script/plugin SI panels) init on page load.
  $(function () { initAll(); });

  c2.actionInputs = {
    init: initTable,
    initAll: initAll
  };

})(window.c2, window.jQuery);
